/**
 * Check if argument is an instance of RegExp.
 *
 * @param arg {*}.
 * @returns {boolean}
 */
export default function isRegExp(arg) {
  return Object.prototype.toString.call(arg) === '[object RegExp]';
}
